import BaseEventHandler from './baseEventHandler';

class AddElementAction extends BaseEventHandler {
  _getSchemaId() {
    return 'urn:shared:user:event:/data-platform/signals/element-action/v1';
  }

  _buildEid(type, { area, product, section, widget }) {
    return `${area}.${product}.${section}.${widget}.${type}`;
  }

  _handleLegacy(input) {
    // Send to the generic add_event handler with corresponding type
    const type = input.element.action;
    this.schemaHelper.handleSchema(
      'add_event',
      undefined,
      'v2',
      {
        eid: this._buildEid(type, input.element),
        type
      },
      this.extras);
  }

  _transformLegacyPromo(type, element, { id, name, creative, position } = {}) {
    return {
      id,
      name,
      creative_name: creative,
      creative_slot: position,
      type,
      eid: this._buildEid(type, element)
    };
  }

  _isPromo(input) {
    return input.promotion && Object.keys(input.promotion).length > 0;
  }
}

export default AddElementAction;
